export default {"src":"/_next/static/media/onboarding3.a45375d0.svg","height":434,"width":399,"blurWidth":0,"blurHeight":0};